<template>

  <div
    class="feed-actions dropdown">
    <button
      class="btn btn-sm btn-light"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false">
      <i class="fas fa-chevron-down" />
    </button>
    <div class="dropdown-menu dropdown-menu-right">
      <button
        class="dropdown-item"
        @click="replyEmail(value)">
        <i class="fas fa-reply" />
        {{ $t('Reply') }}
        </button>
      <button
        class="dropdown-item"
        @click="replyAllEmail(value)">
        <i class="fas fa-reply-all" />
        {{ $t('Reply all') }}
        </button>
      <button
        class="dropdown-item"
        @click="forwardEmail(value)">
        <i class="fas fa-arrow-right" />
        {{ $t('Forward') }}
        </button>
      <button
        class="dropdown-item"
        @click="noRead(value._id)"
        v-if="value.read===true">
        <i class="fas fa-circle" />
        {{ $t('Mark as unread') }}
        </button>
      <button
        class="dropdown-item"
        @click="deleteEmail(value._id)">
        <i class="fas fa-times" />
        {{ $t('Delete') }}
        </button>
    </div>
  </div>

</template>

<script>
export default {
  name: 'EmailAction',
  props: [
    'value'
  ],
  components: {
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    getContentResponse (url) {
      return fetch(url).then(res => {
        return res.text()
      }).then(result => {
        return `<br><br>--<br>${result}`
      })
    },
    replyEmail (data) {
      this.getContentResponse(data.body_media.url).then(body => {
        this.$emit('create', {
          candidate_id: data.candidate_id && data.candidate_id._id ? data.candidate_id._id : data.candidate_id,
          job_id: data.job_id && data.job_id._id ? data.job_id._id : data.job_id,
          type: 'reply',
          parent_email_id: data._id,
          to: data.type === 'received' ? [data.from] : data.to,
          cc: [],
          bcc: [],
          subject: 'Re: ' + data.subject,
          body,
          placement_id: data.placement_id
        })
      })
    },
    replyAllEmail (data) {
      this.getContentResponse(data.body_media.url).then(body => {
        this.$emit('create', {
          candidate_id: data.candidate_id && data.candidate_id._id ? data.candidate_id._id : data.candidate_id,
          job_id: data.job_id && data.job_id._id ? data.job_id._id : data.job_id,
          type: 'replyAll',
          parent_email_id: data._id,
          to: [data.from].concat(data.to || []).filter((v) => { return !v.email.includes('mailquickin.com') }),
          cc: data.cc,
          bcc: [],
          subject: 'Re: ' + data.subject,
          body,
          placement_id: data.placement_id
        })
      })
    },
    forwardEmail (data) {
      this.getContentResponse(data.body_media.url).then(body => {
        this.$emit('create', {
          candidate_id: data.candidate_id && data.candidate_id._id ? data.candidate_id._id : data.candidate_id,
          job_id: data.job_id && data.job_id._id ? data.job_id._id : data.job_id,
          type: 'forward',
          parent_email_id: data._id,
          to: [],
          cc: [],
          bcc: [],
          subject: 'Enc: ' + data.subject,
          body,
          attachments_media: data.attachments_media,
          placement_id: data.placement_id
        })
      })
    },
    /*
    noRead
    */
    noRead (id) {
      this.$store
      .dispatch('updateEmailRead', {
        _id: id,
        read: false
      })
    },
    deleteEmail (id) {
      this.$emit('delete', id)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Email/EmailActions.vue